import { Reducer } from "redux";

import { ApplicationStatefulModule } from "@multiweb/types/react";
import { NAME } from "./constants";
import { reducer } from "./reducer";
import { IControlsState } from "./types";

export {
    createClearControlsValueAction,
    createClearValidationErrorsAction,
    createControlsValueChangedAction,
    createInitControlsValueAction,
    createSetValidationDescriptionsAction,
    createValidateAction,
} from "./actions";
export { REQUIRED_INVALID_STATE_LOC_KEY } from "./locKeys";
export {
    createStableGetMergedValidationErrors,
    getErrors,
    getInitialRawValue,
    getRawValue,
} from "./selectors";
export {
    ControlReduxRawValue,
    ControlsInstance,
    ControlsKey,
    ControlsValueInstantValidationMode,
    IControlsState,
} from "./types";
export {
    areLocalizedErrorsEqual,
    ExplicitValidation,
    IExplicitValidationError,
    IExplicitValidationFnDescription,
    IInstantValidationFnDescription,
    ILocalizedExplicitValidationError,
    InstantValidation,
} from "./validation";

export const controlsModule: ApplicationStatefulModule<typeof NAME, Reducer<IControlsState>> = {
    NAME,
    reducer,
};
